const doc = [({"es":"espagnol", "fr":"français", "en":"anglais", "de":"allemand"})];
module.exports = doc.length <= 1 ? doc[0] : doc;